import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ReviewCommentDialogComponent } from './review-comment-dialog/review-comment-dialog.component';
import { DocumentNodeViewComponent } from './document-node-view/document-node-view.component';
import { ProcedureDocumentViewerComponent } from './procedure-document-viewer/procedure-document-viewer.component';
import { NoteComponent } from './shared-note/note.component';
import { CommentStickyNoteComponent } from './comment-sticky-note/comment-sticky-note.component';
import { CommentsPanelComponent } from './comments-panel.component';

@NgModule({
  declarations: [
    ReviewCommentDialogComponent,
    CommentsPanelComponent,
    DocumentNodeViewComponent,
    ProcedureDocumentViewerComponent,
    NoteComponent,
    CommentStickyNoteComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    TextFieldModule,
    OverlayModule,
    PortalModule,
  ],
  exports: [ProcedureDocumentViewerComponent, CommentStickyNoteComponent, CommentsPanelComponent],
})
export class ReviewCommentsModule {}
